import { render, staticRenderFns } from "./CoachNoteDashboard.vue?vue&type=template&id=4330df4f&scoped=true"
import script from "./CoachNoteDashboard.vue?vue&type=script&lang=js"
export * from "./CoachNoteDashboard.vue?vue&type=script&lang=js"
import style0 from "./CoachNoteDashboard.vue?vue&type=style&index=0&id=4330df4f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4330df4f",
  null
  
)

export default component.exports